var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ItemRow',[_c('ItemWithLabel',{attrs:{"column":_vm.columns[0]}},[_vm._v(" "+_vm._s(_vm.itemData.nickname)+" ")]),_c('ItemWithLabel',{attrs:{"column":_vm.columns[1]}},[_vm._v(" "+_vm._s(_vm.itemData.field1)+" ")]),_c('ItemWithLabel',{attrs:{"column":_vm.columns[2]}},[_vm._v(" "+_vm._s(_vm.itemData.field2)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }